import {
  ADMIN_ROUTES,
  AUTH_ROUTES,
  B2B_ROUTES,
  MENTOR_ROUTES,
  SYSTEM_ROUTES,
  TRAVELLER_ROUTES,
} from 'constants/routes';
import { USER_TYPES } from 'constants/types';
import {
  canViewBookingAgent,
  canViewFinance,
  canViewMaster,
  keyRole,
} from './isRole';

/**
 * Landing page of an organization member, or null for everyone else.
 * FINANCE has no portal screen and the API denies it every organization
 * endpoint, so it gets the 403 page instead of falling through to the
 * traveler signup like a role-less user.
 */
export const getB2BLanding = (user) => {
  if (canViewMaster(user)) return B2B_ROUTES.ADMIN;
  if (canViewBookingAgent(user)) return B2B_ROUTES.AGENT;
  if (canViewFinance(user)) return SYSTEM_ROUTES.NOT_ALLOWED;

  return null;
};

export const redirectByUserType = (user, urlParams = null) => {
  const b2bLanding = getB2BLanding(user);
  if (b2bLanding) return b2bLanding;

  const role = user?.[keyRole]?.[0];

  switch (role) {
    case USER_TYPES.advisor:
      return MENTOR_ROUTES.HOME;
    case USER_TYPES.traveler:
      return TRAVELLER_ROUTES.HOME;
    case USER_TYPES.admin:
      return ADMIN_ROUTES.DASHBOARD;
    default:
      return urlParams?.get('loginAs') === 'advisor'
        ? AUTH_ROUTES.GUIDE_REGISTER
        : AUTH_ROUTES.REGISTER;
  }
};
